export default __webpack_public_path__ + "static/media/load-balancer.7fc899a3.svg";